<template>
  <b-modal
    id="modal-detail"
    size="lg"
    hide-footer
    hide-header
    modal-class="modal-dark"
    centered
  >
    <h4 class="font-bold text-black d-inline-flex mb-0">
      Pengajuan barang rusak
    </h4>
    <div
      class="d-inline-flex ml-1"
      :class="handleStatus('class', res.status)"
    >
      {{ handleStatus('text', res.status) }}
    </div>
    <b-img
      role="button"
      style="cursor:pointer"
      class="float-right"
      src="https://storage.googleapis.com/komerce/assets/icons/close-circle.svg"
      @click="closeModal()"
    />
    <div class="d-flex mt-2 gap-2 mb-2">
      <img
        src="https://storage.googleapis.com/komerce/assets/svg/logo_kompack.svg"
        alt="logo-kompack"
      >
      <div class="text-black text-lg">
        {{ res.warehouse_name }}
      </div>
    </div>
    <BOverlay
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
      class="-mx-5"
    >
      <b-table
        id="table"
        empty-text="Tidak ada data yang ditampilkan."
        responsive
        show-empty
        :fields="fields"
        :items="res.products"
        class="mb-0"
      >
        <template #cell(variant)="data">
          <div v-if="data.item.variant === ''">
            -
          </div>
          <div v-else>
            {{ data.item.variant }}
          </div>
        </template>
      </b-table>
    </BOverlay>
    <div v-if="res.memo">
      <div class="text-[#222222] mt-[12px] font-bold">
        Memo
      </div>
      <div
        class="mt-[12px] textarea-memo"
      >
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="handleMemo(res.memo)" />
      </div>
    </div>
    <div
      v-if="res.status === 'Diajukan'"
      class="d-flex"
    >
      <div class="w-50">
        <b-button
          variant="outline-primary"
          @click="chatButton(res.warehouse_phone)"
        >
          Hubungi Mitra
        </b-button>
      </div>
      <div class="w-50 d-flex justify-content-end gap-3">
        <b-button
          variant="outline-primary"
          @click="confirmReject(res.outbound_id)"
        >
          Tolak
        </b-button>
        <b-button
          variant="primary"
          @click="confirm(res.outbound_id)"
        >
          Setujui
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import chatButton from '@/libs/chatButton'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  props: {
    res: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      chatButton,
      loading: false,
      fields: [
        {
          key: 'nama_product',
          label: 'Nama Produk',
          thClass: 'text-black py-1',
          thStyle: {
            fontSize: '14px',
            color: 'black',
            textTransform: 'capitalize',
          },
          tdClass: 'text-black',
        },
        {
          key: 'variant',
          label: 'Variasi',
          thClass: 'text-black py-1',
          thStyle: {
            fontSize: '14px',
            color: 'black',
            textTransform: 'capitalize',
          },
          tdClass: 'text-black',
        },
        {
          key: 'stok',
          label: 'Stok',
          thClass: 'text-black py-1',
          thStyle: {
            fontSize: '14px',
            color: 'black',
            textTransform: 'capitalize',
          },
          tdClass: 'text-black',
        },
        {
          key: 'total',
          label: 'Jumlah Pengajuan',
          thClass: 'text-black py-1',
          thStyle: {
            fontSize: '14px',
            color: 'black',
            textTransform: 'capitalize',
          },
          tdClass: 'text-black',
        },
      ],
    }
  },

  methods: {
    changeLoading() {
      if (!this.res) {
        this.loading = true
      } else {
        this.loading = false
      }
    },
    handleStatus(part, status) {
      if (part === 'class') {
        if (status === 'Diajukan') return 'status status-waiting'
        if (status === 'Selesai') return 'status status-acc'
        if (status === 'Ditolak') return 'status status-reject'
      }
      if (status === 'Diajukan') return 'Perlu Persetujuan'
      if (status === 'Selesai') return 'Disetujui'
      return status
    },
    confirmReject(id) {
      this.$bvModal.hide('modal-detail')
      this.$swal({
        title: 'Tolak pengajuan Pengeluaran barang',
        text: 'Anda yakin menolak pengajuan?',
        icon: 'warning',
        width: '50%',
        iconHtml: '<img src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png">',
        showCancelButton: true,
        cancelButtonText: 'Batal',
        confirmButtonText: 'Tolak',
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          icon: 'border-0 w-50 my-5',
          confirmButton: 'btn btn-primary px-4',
          cancelButton: 'btn btn-outline-primary mr-1 px-5',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.reject(id)
        } else {
          this.$bvModal.show('modal-detail')
        }
      })
    },
    async reject(id) {
      await this.$http_komship.put(`/v1/komship/outbound/${id}/reject`)
        .then(() => {
          this.$emit('callParentMethod')
          this.$bvModal.hide('modal-detail')
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'AlertCircleIcon',
                text: 'Sukses tolak pengajuan',
                variant: 'success',
              },
            },
            2000,
          )
        }).catch(() => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Gagal',
                icon: 'AlertCircleIcon',
                text: 'Gagal tolak pengajuan, silahkan coba lagi',
                variant: 'danger',
              },
            },
            2000,
          )
        })
    },
    confirm(id) {
      this.$bvModal.hide('modal-detail')
      this.$swal({
        title: 'Pengajuan Pengeluaran barang',
        text: 'Anda yakin menyutujui pengajuan? stok barang akan berkurang ketika disetujui',
        icon: 'warning',
        width: '50%',
        iconHtml: '<img src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png">',
        showCancelButton: true,
        cancelButtonText: 'Batal',
        confirmButtonText: 'Setujui',
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          icon: 'border-0 w-50 my-5',
          confirmButton: 'btn btn-primary px-4',
          cancelButton: 'btn btn-outline-primary mr-1 px-5',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.approve(id)
        } else {
          this.$bvModal.show('modal-detail')
        }
      })
    },
    async approve(id) {
      await this.$http_komship.put(`/v1/komship/outbound/${id}/approve`)
        .then(() => {
          this.$emit('callParentMethod')
          this.$bvModal.hide('modal-detail')
          this.$swal({
            title: 'Pengajuan barang berhasil disetujui',
            text: 'Cek stok terupdate di data produk kamu',
            icon: 'success',
            width: '50%',
            iconHtml: '<img src="https://storage.googleapis.com/komerce/core/icon-popup-success.png">',
            confirmButtonText: 'Oke',
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: {
              icon: 'border-0 w-50 my-5',
              confirmButton: 'btn btn-primary px-4',
              cancelButton: 'btn btn-outline-primary mr-1 px-5',
            },
            buttonsStyling: false,
          }).then(() => {
            this.$router.push({
              path: '/penarikan-barang',
              query: {
                tab: 'menunggu-response',
              },
            })
          })
        }).catch(() => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Gagal',
                icon: 'AlertCircleIcon',
                text: 'Gagal tolak pengajuan, silahkan coba lagi',
                variant: 'danger',
              },
            },
            2000,
          )
        })
    },
    closeModal() {
      this.$bvModal.hide('modal-detail')
    },
    handleMemo(memo) {
      const urlRegex = /(https?:\/\/[^\s]+)/g

      const memoWithLinks = memo ? memo.replace(urlRegex, '<a href="$1" target="_blank">$1</a>') : ''

      return memoWithLinks
    },
  },
}
</script>

<style lang="scss" scoped>
.status {
  padding: 2px 8px;
  border-radius: 100px;
  text-align: center;
  &-acc {
    color: #34A770;
    background: #DCF3EB;
  }
  &-waiting {
    color: #FBA63C;
    background: #FFF2E2;
  }
  &-done {
    color: #4285F4;
    background: #DFF3FF;
  }
  &-reject {
    color: #E31A1A;
    background: #FFEDED;  }
}
.textarea-memo {
  border: 1px solid #e2e2e2;
  padding: 12px 16px;
  font-size: 14px;
  min-height: 100px;
  border-radius: 8px;
}
</style>
